import Editor from "@monaco-editor/react";
import Button from "react-bootstrap/Button";
import {Link} from "react-router-dom";
import ClientProvider from "../ClientProvider";
import React, { useState, useMemo } from 'react';
import ItemsTable from "../ItemsTable/ItemsTable_core";
import {ItemsTableDefault} from "../ItemsTable/ItemsTable";

export default function MonacoEsSearchWidget(props) {

    // const wsProvider = React.useContext(WsProvider);
    const [data, setTableData] = useState([])
    const [sortColumns, setSortColumns] = useState([])
    const [uniqueCount, setUniqueCount] = useState(0)
    const handleEditorChange = (value, event) => {
        props.onChange(value)
    }

    return (
        <>
        <Editor
            height="30vh"
            defaultLanguage="json"
            value={props.value}
            onChange={handleEditorChange}
            theme="vs-dark"
            options={
                {
                    tabSize: 2,
                    minimap: { enabled: false }
                }
            }
        />
        <Button
            variant="secondary" onClick={ () => {
                // Simply call the search function - query building is handled elsewhere
                props.options.onSearch(
                    props.value,
                    props.schema.options.campaign,
                    (response) => {
                        console.log('Backend response:', response);
                        const es_response = response.es_response;
                        
                        const count = es_response.aggregations.unique_collapse_count?.value || 0;
                        setUniqueCount(count);
                        
                        // Process hits from filter_result
                        let tableData = [];
                        if (es_response.hits && es_response.hits.hits) {
                            const hits = es_response.hits.hits;
                            if (Array.isArray(hits)) {
                                tableData = hits.map((hit, index) => ({
                                    id: hit._id || '',
                                    client: hit.fields?.client_value?.[0] || '',
                                    title: hit.fields?.title_value?.[0] || '',
                                    degree: hit.fields?.degree_values?.join(", ") || '',
                                    url: hit.fields?.url_value?.[0] || '',
                                    index: hit._index || ''
                                }));
                            }
                        }
                        
                        console.log('Table data:', tableData);
                        setTableData(tableData);
                    }
                )
            }}
            style={{ marginRight: '8px', marginTop: '12px' }}
        >Test</Button>
        <Button onClick={() => {
            const query = {
                query: {
                    match_all: {}
                }
            }
            props.onChange(JSON.stringify(query, null, 4))
        }
        } style={{ marginRight: '8px', marginTop: '12px' }}>Match All</Button>
        <Button onClick={() => {
            const query = {
                query: {
                    query_string: {
                        query: "title_value: *",
                        default_field: "title_value",
                        allow_leading_wildcard: true,
                        analyze_wildcard: true,
                        default_operator: "OR",
                        fuzziness: 0
                    }
                }
            }
            props.onChange(JSON.stringify(query, null, 4))
        }
        } style={{ marginRight: '8px', marginTop: '12px' }}>Query String</Button>
        <Button onClick={() => {
            const query = {
                "query": {
                    "terms": {
                        "degree_group_values.keyword": ["MASMBA", "BA"]
                    }
                }
            }
            props.onChange(JSON.stringify(query, null, 4))
        }
        } style={{ marginRight: '8px', marginTop: '12px' }}>Terms</Button>
        <Button onClick={() => {
            const query = {
                "query": {
                    "bool": {
                        "must_not": {
                            "terms": {
                                "degree_group_values.keyword": ["MASMBA", "BA"]
                            }
                        }
                    }
                }
            }
            props.onChange(JSON.stringify(query, null, 4))
        }
        } style={{ marginTop: '12px' }}>Not Terms</Button>
        <Link to={{ pathname:"https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-query-string-query.html#query-string-syntax"}}
              target="_blank" style={{ marginTop: '12px', marginLeft: '8px' }}>Query String Syntax</Link>

        {uniqueCount > 0 && (
            <div style={{ margin: '20px 0', padding: '10px', borderRadius: '5px', border: '1px solid #dee2e6' }}>
                <strong>Unique collapse_value count: {uniqueCount}</strong>
            </div>
        )}

        {data.length > 0 && (
            <div className='content'>
                 <ItemsTableDefault
                    tableData={data}
                    sortColumns={sortColumns}
                    setSortColumns={setSortColumns}
                    // filterColumns={filterColumns}
                    // setFilterColumns={setFilterColumns}
                />
            </div>
        )}
        </>
    )
  };